module.exports = __webpack_public_path__ + "img/0_d.92c9c027.jpg";